export const MuiTableCell = {
  styleOverrides: {
    root: {
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '100%',
      padding: '16.5px 8px',
      border: 'none',
    },
    head: {
      fontWeight: '600',
      fontSize: '12px',
      lineHeight: '100%',
      color: '#F1F1F1',
      backgroundColor: '#1a3746',
    },
    body: {
      color: '#F1F1F1',
      backgroundColor: '#002031',
      border: 'none',
    },
  },
}
